import FAQCard from "./FAQCard";

const FrequentlyAskedQuestions = () => {
  const faqs = [
    {
      Title: "What is the Sootchy Education Program (SEP)?",
      Content:
        "The Sootchy Education Program (SEP) is an employer-sponsored 529 higher education savings platform. It enables employees, in collaboration with their employers, to make contributions to a child’s college or other higher education funds and grow savings using a variety of investment options.",
    },
    {
      Title: "Who can participate?",
      Content:
        "Employees who are invited by their employer to join SEP can participate. The program is designed to help parents, guardians, and employees save for their children’s education or their own through a 529 savings plan.",
    },
    {
      Title: "How does it work?",
      Content:
        "Employees contribute to a 529 account through automated payroll deductions, with the option for employers to match contributions. SEP also allows for additional funding from friends and family Gifting, helping employees save more efficiently.",
    },
    {
      Title: "What are the benefits?",
      Content: `
        Employer Matching: Employers can match employee contributions, boosting savings potential.

Tax Advantages: Contributions grow tax-deferred, and withdrawals for qualified expenses are tax-free.

Easy Setup: SEP is easy to set up and manage, with online access and automated payroll deductions.
        `,
    },
    {
      Title: "How do I get started?",
      Content:
        "To get started, you need to receive an invite from your employer. Once you’ve received the invite, you can set up your account online in just a few minutes by entering your personal and beneficiary details.",
    },
    {
      Title: "Can I change my beneficiary?",
      Content:
        "Yes, you can change your beneficiary at any time. You can transfer the funds to another family member if needed.",
    },
    {
      Title: "Can I use funds for non-education expenses?",
      Content:
        "SEP funds are intended to be used for qualifying education expenses, including tuition, fees, room and board, and supplies. For non-education expenses, taxes and withdrawal penalties may apply.",
    },
    {
      Title: "Is there a minimum contribution amount?",
      Content:
        "There is no minimum required contribution amount, and contributions can be made through small, consistent payroll deductions, making it easy for employees to save.",
    },
    {
      Title: "Can I save for beneficiaries other than my children?",
      Content:
        "Yes, if you are saving for your own education or any other eligible beneficiary, you can participate in the program and start saving for your future.",
    },
  ];

  const faq = faqs.map((item: any) => ({
    title: item.Title,
    content: item.Content,
    open: false,
  }));

  return (
    <>
      <div className="flex space-x-4 pt-[40px] pb-[32px]">
        <button className="flex items-center h-[36px] px-[8px] font-semibold text-white bg-brand-default pr-[12px] rounded-[58px] shadow-buttonPrimary">
          General
        </button>
        {/* <button>Vesting</button>
        <button>Withdrawal</button> */}
      </div>

      <FAQCard items={faq} />
    </>
  );
};

export default FrequentlyAskedQuestions;
